export const ARIA_ATTRIBUTES = {
  'aria-describedby': 'country-info-message',
};

export const BATCHED_QUERY_OPTIONS_OVERRIDES = {
  context: {
    isBatchedQuery: true,
  },
};

/**
 * BE: We need 3DS 2.0 to be ramped before taking BE traffic
 * BR: We need to debug the conversion gap between lite and xoon for BR
 * NL: We need 3DS 2.0 to be ramped before taking NL traffic
 */
export const LITE_INELIGIBLE_COUNTRIES = ['BR', 'BE', 'NL'];
